import { Avatar, Grid, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import axios from "axios"
import { getAux } from "../store/features/auxSlice"
import { getAuth } from "../store/features/authSlice"

moment.locale("es")
const { REACT_APP_API_ROUTE: API_ROUTE, REACT_APP_STATIC_ROUTE: STATIC_ROUTE } =
  process.env

export const IphonePreview = ({ element }) => {
  const auth = useSelector(getAuth)
  const [user, setUser] = useState(null)

  useEffect(() => {
    getUser()
  }, [element])

  const getUser = async () => {
    try {
      const endpoint = `/user/${element.user}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: {
          Authorization: auth.data.jwtToken,
        },
      })
      setUser(data)
    } catch (e) {
      alert(e.message)
    }
  }

  if (!user || !element) return <div></div>

  switch (element.postType) {
    case 1:
    case 2:
    case 3:
    case 4:
      return <StandardPost element={element} user={user} />
    case 5:
      return <Notification element={element} user={user} />
  }
}

const Notification = ({ element, user }) => {
  return (
    <Grid container pl={5} pr={5} pt={3} sx={{ fontSize: "0.7rem" }}>
      <Grid item xs={12} sx={{ zIndex: 999 }}>
        <Grid
          container
          pl={4}
          pr={5}
          pt={7}
          height={600}
          style={{ color: "white" }}
        >
          <Grid
            item
            xs={12}
            bgcolor={"rgba(255, 255, 255, 0.2)"}
            height={100}
            overflow="hidden"
            p={2}
            sx={{ borderRadius: 4, backdropFilter: "blur(50px)" }}
          >
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Avatar
                  variant="rounded"
                  alt="C"
                  src="/logo512.png"
                  sx={{ width: 65, height: 65 }}
                />
              </Grid>
              <Grid item xs={9}>
                <span style={{ fontSize: "1rem", lineHeight: 1 }}>
                  {element.title}
                </span>
                <br />
                <span>{element.content}</span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const StandardPost = ({ element, user }) => {
  const aux = useSelector(getAux)
  const [postColor, setPostColor] = useState("white")

  useEffect(() => {
    switch (element.postType) {
      case 1:
        setPostColor("blue")
        break
      case 2:
        setPostColor("teal")
        break
      case 3:
        setPostColor("mediumpurple")
        break
      case 4:
        setPostColor("orange")
        break
      default:
        setPostColor("gray")
        break
    }
  }, [element])

  return (
    <Grid container pl={5} pr={5} pt={3} sx={{ fontSize: "0.7rem" }}>
      <Grid item>
        <Grid
          container
          pl={4}
          pr={5}
          pt={6}
          height={600}
          bgcolor="black"
          style={{ color: "white" }}
        >
          <Grid item xs={2}>
            <Avatar
              alt="U"
              src={STATIC_ROUTE + user.cover}
              sx={{ width: 50, height: 50 }}
            />
          </Grid>
          <Grid item xs={10}>
            <Grid container spacing={0.25}>
              <Grid item xs={12}>
                <span style={{ color: "white" }}>
                  {user.personType === 1 ? user.name : user.businessName}
                </span>{" "}
                <span style={{ color: "gray" }}>@{user.id}</span>
              </Grid>
              <Grid item xs={12}>
                <span style={{ color: "gray" }}>
                  {moment(element.insertionDate).startOf("day").fromNow()}
                </span>
              </Grid>
              <Grid item xs={12}>
                <span style={{ overflow: "hidden" }}>{element.copy}</span>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: 2,
                }}
              >
                <img
                  src={STATIC_ROUTE + element.cover}
                  width={"100%"}
                  style={{ borderRadius: 10 }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null // prevents looping
                    currentTarget.src = "/no-image-available.png"
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    background: postColor,
                    paddingRight: 10,
                    paddingLeft: 10,
                    paddingTop: 7,
                    paddingBottom: 7,
                  }}
                >
                  {
                    aux.data.postTypes.find(
                      (item) => item.id === element.postType
                    ).value
                  }
                </span>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: "1.4rem",
                    fontWeight: "bolder",
                    lineHeight: 1.1,
                  }}
                  mt={1}
                >
                  {element.title}
                </Typography>
              </Grid>
              {[3].some((item) => item === element.postType) && (
                <Grid item xs={12} color="mediumpurple">
                  <span style={{ fontSize: "0.9rem" }}>{element.topic}</span>
                </Grid>
              )}
              {[2, 3, 4].some((item) => item === element.postType) && (
                <Grid item xs={12}>
                  {element.description}
                </Grid>
              )}
              {[1].some((item) => item === element.postType) && (
                <Grid item xs={12}>
                  <Grid container justifyContent="space-between">
                    <Grid item color={"gray"}>
                      <span>Precio:</span>
                    </Grid>
                    <Grid item color={"green"}>
                      {element.price > 0 ? (
                        <>
                          {
                            aux.data.coins.find(
                              (item) => item.id === element.coin
                            ).value
                          }{" "}
                          {element.price}
                        </>
                      ) : (
                        <span>Gratis</span>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {[1].some((item) => item === element.postType) && (
                <Grid item xs={12}>
                  <Grid container justifyContent="space-between">
                    <Grid item color={"gray"}>
                      <span>Inicio:</span>
                    </Grid>
                    <Grid item>
                      <span>{moment(element.startDate).format("LL")}</span>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {[1, 2].some((item) => item === element.postType) && (
                <Grid item xs={12}>
                  <Grid container justifyContent="space-between">
                    <Grid item color={"gray"}>
                      {element.postType === 1 && <span>Finalización:</span>}
                      {element.postType === 2 && <span>Vigencia:</span>}
                    </Grid>
                    <Grid item>
                      <span>{moment(element.finishDate).format("LL")}</span>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
